import api from '@/api/axios.config';

class FeedbackService {
	async sendFeedback(feedback: string, email: string): Promise<void> {
		return api.post('/feedback', { feedback, email });
	}
}

export default new FeedbackService();
